import { Box, styled } from '@mui/material';

export const InitialInfoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '& .MuiList-root': {
    marginBottom: '34px',

    [theme.breakpoints.up('lg')]: {
      marginTop: '24px',
      marginBottom: '24px',
    },
  },

  '@-moz-document url-prefix()': {
    scrollbarColor: `${theme.palette.colors.scrollOnPrimaryBackground} transparent`,
    scrollbarWidth: 'thin',
  },
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.colors.scrollOnPrimaryBackground,
    borderRadius: '5px',
  },

  [theme.breakpoints.up('lg')]: {
    height: 'auto',
    overflowY: 'auto',
  },
}));
